import {
  ISearchGoogleInput,
  ISearchInput,
  ISearchKeywordSuggestInput,
  ISearchParamsOutput,
  ISearchPopularInput,
  ISearchRecentInput,
  ISearchStoreParamsOutput,
  ISearchSuggestInput,
} from "types/api/search";
import gate from "../gate";
import client from "../http-clients/api";

const searchApi = {
  getScriptAndProduct: (params: ISearchParamsOutput) =>
    gate.get<ISearchGoogleInput, never, ISearchParamsOutput>({
      client,
      url: "/search/google",
      params: params,
    }),
  storeSearchResult: (params: ISearchStoreParamsOutput) =>
    gate.post<ISearchInput, never, ISearchStoreParamsOutput>({
      client,
      url: "/search/store",
      params: params,
    }),
  search: (params: ISearchParamsOutput) =>
    gate.get<ISearchInput, never, ISearchParamsOutput>({
      client,
      url: "/utils/search",
      params: params,
    }),
  popularSearch: () =>
    gate.get<ISearchPopularInput, never, never>({
      client,
      url: "/utils/popular",
    }),
  recentSearch: () =>
    gate.get<ISearchRecentInput, never, never>({
      client,
      url: "/utils/recent?recache=1",
    }),
  suggestSearch: (params: string) =>
    gate.get<ISearchSuggestInput, never, never>({
      client,
      url: `/utils/suggest/products?term=${params}&product_count=3&category_count=3`,
    }),
  suggestKeyword: (params: string) =>
    gate.get<ISearchKeywordSuggestInput, never, never>({
      client,
      url: `/utils/suggest/keywords?term=${params}&count=5`,
    }),
  removeRecent: (term: string) =>
    gate.get<ISearchKeywordSuggestInput, never, never>({
      client,
      url: `/utils/recent/remove?term=${term}`,
    }),
};

export default searchApi;
